module.exports = __webpack_public_path__ + "PERUVIANhome-5.32af1228.png";